module.exports = __webpack_public_path__ + "static/media/7ICJ2.a58941d7.jpg";